import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
import coachRoutes from "./coaches";
import clientRoutes from "./clients";
import publicRoutes from "./public";
import Login from "@/pages/account/auth/login";
import { unauthRoute } from "./safeGuards";

import navLayout from "@/layouts/nav";

let router = new Router({
  mode: "history",
  routes: [
    unauthRoute("", Login, "login"),
    ...publicRoutes,
    {
      path: "/",
      component: navLayout,
      children: [...coachRoutes, ...clientRoutes]
    }
  ]
});

export default router;
